import React from "react";
import { useParams } from "react-router-dom";
import Layout from "../../Layout";
import TelephonyLeftNav from "../../Layout/TelephonyLeftNav";
import CallDetails from "../../containers/CallDetails";

export default function CallDetailsPage() {
  const { callId } = useParams();
  
  return (
    <Layout leftNav={<TelephonyLeftNav />}>
      <CallDetails callId={callId} />
    </Layout>
  );
}